module.exports = __webpack_public_path__ + "static/parser-9ae627c2b761c06422fab6e772ea09b9.png";